import "../../assets/styles/InfoUser.css";
import React, { useState } from "react";

function DataConfirm({ user, dataCheck, dataUpdate, webSetting }) {
  const [copySuccess, setCopySuccess] = useState("");
  const mailTo = webSetting?.email || "";
  const phoneNumber = webSetting?.phone_number || "";
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const requestCode = user.request_code || "";

  const REQUEST_TYPES = {
    full_name: "Thay đổi họ và tên",
    phone_number: "Thay đổi số điện thoại",
    email: "Thay đổi email",
    bank: "Thay đổi tài khoản ngân hàng",
    birthday: "Thay đổi ngày sinh",
    forget_password: "Cấp lại mật khẩu đăng nhập",
    forget_password_withdraw: "Cấp lại mật khẩu rút tiền",
  };

  const requestType = REQUEST_TYPES[user.update_type] || user.update_type || "Yêu cầu thay đổi thông tin";
  const content = `Tên đăng nhập: ${user.account}\r\nMã yêu cầu: ${requestCode}`;

  const copyToClipboardAndSendMailSMS = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopySuccess("Đã sao chép nội dung.");
      setTimeout(() => setCopySuccess(""), 30000);
      if (user.send_type === "phone_number" && isMobile) {
        window.location.href = `sms:${phoneNumber}?body=${encodeURIComponent(content)}`;
      }
    } catch (err) {
      setCopySuccess("Sao chép không thành công.");
      console.error("Không thể sao chép văn bản: ", err);
    }
  };

  const sendButton = user.send_type === "email" ? (
    <div className="btn-send type-send">
      <a
        href={isMobile
          ? `mailto:${mailTo}?subject=${encodeURIComponent(requestType.toUpperCase())}&body=${encodeURIComponent(content)}`
          : `https://mail.google.com/mail/?view=cm&fs=1&to=${mailTo}&su=${encodeURIComponent(requestType.toUpperCase())}&body=${encodeURIComponent(content)}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        Gửi Email
      </a>
    </div>
  ) : isMobile && user.send_type === "phone_number" ? (
    <div className="btn-send type-send">
      <a href={`sms:${phoneNumber}?body=${encodeURIComponent(content)}`} target="_blank" rel="noopener noreferrer">
        Gửi Tin Nhắn
      </a>
    </div>
  ) : null;

  return (
    <div className="content-text-confirm">
      <div className="request-confirm-info">
        <div className="item-info"><p className="label-info">Yêu cầu:</p><p className="info-text">{requestType}</p></div>
        <div className="item-info"><p className="label-info">Tên đăng nhập:</p><p className="info-text">{user.account}</p></div>
        <div className="item-info"><p className="label-info">Mã yêu cầu:</p><p className="info-text request-code-full">{requestCode || "Đang tạo..."}</p></div>
      </div>
      {user.update_type === "forget_password_withdraw" && <p className="request-code-reminder">Vui lòng lưu mã yêu cầu để tra cứu kết quả khi cần.</p>}
      <div className="box-footer">
        <div className="btn-copy-text">
          <button type="button" onClick={copyToClipboardAndSendMailSMS}>Sao chép nội dung</button>
          {copySuccess && <p className="ss-copy">{copySuccess}</p>}
        </div>
        {sendButton}
      </div>
    </div>
  );
}

export default DataConfirm;
